<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>永續專區ESG</h2>
            <h2 style="padding-top: 10px;">G公司治理</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd;">公司治理條約</h3>
                <!-- <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p> -->
            </div>
        </div>
    </div>
</section>
<!-- End About Area -->


<section>
    <div class="container">
        <table class="styled-table">
            <thead>
                <tr>
                    <th style="width: 70%;">檔案名稱</th>
                    <!-- <th style="width: 15%;">大小</th> -->
                    <th>下載</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let file of fileList">
                    <td>{{file.fileName}}</td>
                    <!-- <td>{{file.fileSize}}</td> -->
                    <td><a href="/assets/files/{{file.fileName}}" download="{{file.fileName}}"><i class="fas fa-download"></i></a></td>
                </tr>
            </tbody>
        </table>
    </div>
</section>

<!-- Start Features Area -->
<!-- <section class="features-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> 專業顧問團隊</span></li>
                    <li><span><i class='bx bx-check-double'></i> 軟硬體解決方案整合</span></li>
                    <li><span><i class='bx bx-check-double'></i> 產官學合作</span></li>
                    <li><span><i class='bx bx-check-double'></i> 企業轉型諮詢</span></li>
                    <li><span><i class='bx bx-check-double'></i> 旗艦級專案導入</span></li>
                </ul>
            </div>
        </div>

    </div>
</section> -->

<!-- End Features Area -->

<section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd;">參與活動</h3>
            </div>
        </div>
    </div>
</section>


<section class="team-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content: space-evenly;">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/about/pic_05.jpg" alt="image" style="max-width: 60%;">
            </div> -->
            <img src="assets/img/esg/魚與漁.png" class="image" alt="image">

            <div class="content">
                <h3 style="font-size: 24px;color: #2781bd;">ON-AIR!【魚與漁與餘】市場裡的永續海鮮採購</h3>
                <p style="font-size: 18px;color: black;">
                    了解了SDG 14「保育及永續利用海洋生態系」的重要性。這次活動讓我們認識了四季海鮮的多樣性，並學習了如何實踐永續飲食與購魚。<br>通過這次活動，我們更加明白了保護海洋生態系統對於生物多樣性的重要性。我們承諾在日常業務中推動可持續的海鮮選擇，支持海洋環境的保護，並提倡負責任的消費方式。<br>我們將繼續遵循透明和誠信的經營理念，確保我們的業務活動對環境產生正面影響。我們相信，只有每一個企業都能夠積極參與海洋保育，才能確保我們的海洋資源得以永續利用，共創美好的未來。
                </p>
            </div>
        </div>
    </div>
</section>
<!-- <app-subscribe></app-subscribe> -->